<template>
  <v-menu
    v-model="showDate"
    :disabled="loading"
    :close-on-content-click="false"
    :nudge-right="0"
    lazy
    offset-y
    full-width
    min-width="290px" >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="display"
        :label="dateLabel"
        :rules="rulesIsDate"
        prepend-icon="mdi-calendar"
        readonly
        v-on="on" />
    </template>
    <v-card>
      <v-card-text class="px-0 py-0">
        <v-tabs
          v-model="selectedTab"
          fixed-tabs>
          <v-tab key="dateTab">
            <slot name="dateIcon">
              <v-icon>mdi-calendar</v-icon>
            </slot>
          </v-tab>
          <v-tab
            key="timeTab">
            <slot name="timeIcon">
              <v-icon>mdi-clock-outline</v-icon>
            </slot>
          </v-tab>
          <v-tab-item key="dateTab">
            <v-date-picker
              v-model="pickerDate"
              :locale="locale"
              :min="datePickerMin"
              :max="datePickerMax"
              elevation="15"
              offset-y
              width="320px"
              min-width="290px"
              @input="showTimePicker()"/>
          </v-tab-item>
          <v-tab-item key="timeTab">
            <v-time-picker
              ref="timeTab"
              v-model="pickerTime"
              format="24hr"
              scrollable
              elevation="15"
              class="v-time-picker-custom"
              full-width
            />
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <slot
          :parent="this"
          name="actions">
          <v-btn
            flat
            color="tertiary"
            @click.native="onClear">
            {{ $t('Clear date') }}
          </v-btn>
          <v-btn
            flat
            color="primary"
            @click="onOk">
            {{ $t('OK') }}
          </v-btn>
        </slot>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: {
    componentKey: {
      type: Number,
      required: true,
      default: 1
    },
    rulesIsDate: {
      type: Array,
      required: true,
      isDate: [ v => true ]
    },
    dateLabel: {
      type: String,
      required: true,
      default: ''
    },
    initialDate: {
      type: Date | Boolean,
      required: true,
      default: false
    },
    dateFormat: {
      type: String,
      required: true
    },
    timeFormat: {
      type: String,
      required: true
    },
    minDate: {
      type: Date | Boolean,
      required: true,
      default: false
    },
    maxDate: {
      type: Date | Boolean,
      required: true,
      default: false
    },
    clearDate: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: () => ({
    showDate: false,
    locale: 'en',
    pickerDate: '',
    pickerTime: '',
    display: '',
    rules: {
      isDate: [ v => true ]
    },
    selectedTab: 0
  }),
  computed: {
    datePickerMin () {
      if (!this.minDate) {
        return ''
      }
      return this.Maglink.GetCustomDate(this.minDate, 'yyyy-mm-dd')
    },
    datePickerMax () {
      if (!this.maxDate) {
        return ''
      }
      return this.Maglink.GetCustomDate(this.maxDate, 'yyyy-mm-dd')
    }
  },
  watch: {
    initialDate: {
      handler: function (newDate, oldDate) {
        var dt = new Date()
        if (!newDate) {
          this.display = ''
        } else {
          this.formatDisplay(newDate)
          dt = newDate
        }
        var timestamp = dt.getTime() / 1000
        this.pickerDate = this.Maglink.GetCustomDateTime(timestamp, 'yyyy-MM-dd').substr(0, 10)
        this.pickerTime = this.Maglink.GetCustomDateTime(timestamp, 'yyyy-MM-dd').substr(11, 5)
      },
      immediate: true

    }
  },
  mounted () {
    this.locale = localStorage.currentLanguage
    var dt = new Date()
    if (!this.initialDate) {
      this.display = ''
    } else {
      this.formatDisplay(this.initialDate)
      dt = this.initialDate
    }
    var timestamp = dt.getTime() / 1000
    this.pickerDate = this.Maglink.GetCustomDateTime(timestamp, 'yyyy-MM-dd').substr(0, 10)
    this.pickerTime = this.Maglink.GetCustomDateTime(timestamp, 'yyyy-MM-dd').substr(11, 5)
  },
  methods: {
    formatDisplay (dateTime) {
      var timestamp = dateTime.getTime() / 1000
      var customDateTime = this.Maglink.GetCustomDateTime(timestamp, this.dateFormat)
      this.display = customDateTime.substr(0, 16)
    },
    selectDateTime () {
      if (this.pickerDate !== '' && this.pickerTime !== '') {
        let dateItems = this.pickerDate.split('-')
        let timeItems = this.pickerTime.split(':')
        let dt = new Date(+(dateItems[0] * 1), (dateItems[1] * 1) - 1, +(dateItems[2] * 1), +(timeItems[0] * 1), +(timeItems[1] * 1))
        this.formatDisplay(dt)
        return dt
      }
      return false
    },
    onOk () {
      var date = this.selectDateTime()

      this.resetPicker()
      this.showDate = false
      this.$emit('getDate', this.componentKey, date)
    },
    onClear () {
      this.resetPicker()
      this.display = ''
      this.pickerDate = ''
      this.pickerTime = ''
    },
    resetPicker () {
      this.selectedTab = 0
      if (this.$refs.timeTab) {
        this.$refs.timeTab.selectingHour = true
      }
    },
    showTimePicker () {
      this.selectDateTime()
      this.selectedTab = 1
    }
  }
}
</script>
